// Predykcja ruchu po stronie klienta z rekoncyliacją: klient od razu przesuwa postać,
// serwer potwierdza (ack) numer kroku i autorytatywną pozycję, klient odtwarza niepotwierdzone kroki.
import { step, type BlockedFn } from '../world/physics.js';

export interface PendingStep { seq: number; dx: number; dy: number }

export class Predictor {
  seq = 0;
  pending: PendingStep[] = [];
  constructor(public x: number, public y: number, private tile: number, private blocked: BlockedFn) {}

  /** Lokalny krok; zwraca komendę do wysłania. */
  apply(dx: number, dy: number): PendingStep {
    const s: PendingStep = { seq: ++this.seq, dx, dy };
    [this.x, this.y] = step(this.x, this.y, dx, dy, this.tile, this.blocked);
    this.pending.push(s);
    if (this.pending.length > 100) this.pending.shift();
    return s;
  }

  /** Ack z serwera. Zwraca błąd predykcji w metrach (do telemetrii i wygładzania). */
  reconcile(ackSeq: number, sx: number, sy: number): number {
    const beforeX = this.x, beforeY = this.y;
    this.pending = this.pending.filter((p) => p.seq > ackSeq);
    let x = sx, y = sy;
    for (const p of this.pending) [x, y] = step(x, y, p.dx, p.dy, this.tile, this.blocked);
    this.x = x; this.y = y;
    return Math.hypot(beforeX - x, beforeY - y);
  }

  teleport(x: number, y: number): void {
    this.x = x; this.y = y; this.pending = [];
  }
}
